<!-- Footer avec hauteur minimale pour éviter les layout shifts -->
<footer class="footer-area pt-75" [style.min-height.px]="400">
  <div class="container">
    <div class="row gy-4 justify-content-between align-items-start">
      <!-- Logo + Mission avec hauteur fixe -->
      <div class="col-lg-4 col-md-6">
        <div class="single-footer-widget" [style.min-height.px]="180">
          <div class="widget-logo mb-3" [style.height.px]="80">
            <a routerLink="/">
              <img
                src="../../../../assets/images/afro-logo-small.png"
                width="120"
                height="60"
                loading="lazy"
                alt="Logo AfroTech Hub"
                [style.aspect-ratio]="'2/1'"
              />
            </a>
          </div>
          <div class="footer-content-wrapper" [style.min-height.px]="80">
            <p class="footer-text">
              Mettre en lumière les avancées technologiques en Afrique
            </p>
            <p class="footer-quote fst-italic mt-3">
              « La tech est notre avenir, donnons-lui une voix africaine. »
            </p>
          </div>
        </div>
      </div>
      
      <!-- Navigation avec hauteur fixe -->
      <div class="col-lg-3 col-md-6">
        <div class="single-footer-widget" [style.min-height.px]="180">
          <h5 class="footer-title" [style.height.px]="40">Navigation</h5>
          <ul class="footer-links" [style.min-height.px]="120">
            <li [style.height.px]="32"><a routerLink="about-us">À propos de nous</a></li>
            <li [style.height.px]="32"><a routerLink="terms-of-service">Termes d'utilisation</a></li>
            <li [style.height.px]="32"><a routerLink="privacy-policy">Politique de confidentialité</a></li>
          </ul>
        </div>
      </div>
      
      <!-- Contact avec hauteur fixe -->
      <div class="col-lg-3 col-md-6">
        <div class="single-footer-widget" [style.min-height.px]="180">
          <h5 class="footer-title" [style.height.px]="40">Contact</h5>
          <ul class="footer-links" [style.min-height.px]="120">
            <li [style.height.px]="32"><a routerLink="contact">Formulaire de contact</a></li>
            <li [style.height.px]="32"><a href="mailto:contact@afrotech-hub.com">contact@afrotech-hub.com</a></li>
            <li [style.height.px]="32"><span>Paris, France</span></li>
          </ul>
        </div>
      </div>
      
      <!-- Réseaux sociaux avec hauteur fixe -->
      <div class="col-lg-2 col-md-6">
        <div class="single-footer-widget" [style.min-height.px]="180">
          <h5 class="footer-title" [style.height.px]="40">Suivez-nous</h5>
          <ul class="widget-social" [style.min-height.px]="60">
            <li><a href="https://whatsapp.com/channel/0029VahtDxc6hENtQQWQRk17" target="_blank" rel="noopener" [style.width.px]="44" [style.height.px]="44"><i class="ri-whatsapp-line"></i></a></li>
            <li><a href="https://x.com/afrotech_hub" target="_blank" rel="noopener" [style.width.px]="44" [style.height.px]="44"><i class="flaticon-twitter"></i></a></li>
            <li><a href="https://www.facebook.com/afrotechub/" target="_blank" rel="noopener" [style.width.px]="44" [style.height.px]="44"><i class="flaticon-facebook"></i></a></li>
            <li><a href="https://www.instagram.com/afrotech_hub" target="_blank" rel="noopener" [style.width.px]="44" [style.height.px]="44"><i class="flaticon-instagram"></i></a></li>
            <li><a href="https://www.linkedin.com/company/afrotechhub/" target="_blank" rel="noopener" [style.width.px]="44" [style.height.px]="44"><i class="ri-linkedin-fill"></i></a></li>
            <li><a href="https://youtube.com/channel/UC60eYhuHatzPs-qTtyudIFg?sub_confirmation=1" target="_blank" rel="noopener" [style.width.px]="44" [style.height.px]="44"><i class="ri-youtube-fill"></i></a></li>
          </ul>
        </div>
      </div>
    </div>
    
    <!-- Séparateur avec marge fixe -->
    <hr class="my-4" [style.margin.px]="16" />
    
    <!-- Zone copyright avec hauteur fixe -->
    <div class="copyright-area text-center" [style.min-height.px]="60">
      <div class="copyright-content" [style.line-height]="1.4">
        <span>© {{ currentYear || 2025 }} <a routerLink="/" class="fw-semibold">AfroTech Hub</a> — Tous droits réservés.</span>
        <br />
        <span class="fst-italic">Design & développement by </span>
        <a routerLink="/afrotech-solutions" class="text-light text-decoration-underline">AfroTech Solutions</a>
      </div>
    </div>
  </div>
</footer>